import { CAT_NECESSARY, CAT_ANALYTICS } from "../constants.js";

const translation = {
  consentModal: {
    title: "Aviso de galletas informáticas",
    description:
      "Usamos galletas informáticas esenciales para garantizar que este sitio web funcione correctamente. También usamos galletas informáticas de seguimiento opcionales para ayudarnos a comprender cómo interactúas con nuestro sitio. Estas galletas solo se establecerán con tu consentimiento.",
    acceptAllBtn: "Aceptar todas",
    acceptNecessaryBtn: "Rechazar todas",
    showPreferencesBtn: "Gestionar preferencias individuales",
  },
  preferencesModal: {
    title: "Gestionar preferencias de galletas informáticas",
    acceptAllBtn: "Aceptar todas",
    acceptNecessaryBtn: "Rechazar todas",
    savePreferencesBtn: "Aceptar selección actual",
    closeIconLabel: "Cerrar ventana",
    sections: [
      {
        title: "Uso de galletas informáticas",
        description:
          "Usamos galletas informáticas para respaldar las funciones esenciales de este sitio web y mejorar tu experiencia de navegación.",
      },
      {
        title: "Galletas informáticas estrictamente necesarias",
        description:
          "Estas galletas son esenciales para el correcto funcionamiento del sitio web, por ejemplo, para la autenticación de usuarios.",
        linkedCategory: CAT_NECESSARY,
        cookieTable: {
          headers: {
            name: "Nombre",
            domain: "Servicio",
            description: "Descripción",
            expiration: "Caducidad",
          },
          body: [
            {
              name: "_care_leavers_social_hub_session",
              domain: "www.secure-messaging.co.uk",
              description:
                "Galleta informática establecida por la Plataforma Comunitaria Digital para la autenticación de usuarios.",
              expiration: "Sesión",
            },
            {
              name: "CSRF-TOKEN",
              domain: "www.secure-messaging.co.uk",
              description:
                "Galleta informática establecida por la Plataforma Comunitaria Digital para la autenticación de usuarios",
              expiration: "Sesión",
            },
            {
              name: "__cf_bm",
              domain: ".www.secure-messaging.co.uk",
              description:
                "Esta galleta informática se utiliza para diferenciar humanos de robots y proteger el sitio web contra abusos automatizados. No se recopilan datos personales.",
              expiration: "30 minutos",
            },
          ],
        },
      },
      {
        title: "Analítica",
        description:
          "Las galletas informáticas utilizadas para la analítica ayudan a recopilar datos que permiten a los servicios comprender cómo los usuarios interactúan con un servicio en particular. Estas perspectivas permiten mejorar el contenido y desarrollar mejores funciones que mejoran la experiencia del usuario.",
        linkedCategory: CAT_ANALYTICS,
        cookieTable: {
          headers: {
            name: "Nombre",
            domain: "Servicio",
            description: "Descripción",
            expiration: "Caducidad",
          },
          body: [
            {
              name: "_ga",
              domain: "Google Analytics",
              description:
                'Galleta informática establecida por <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Caduca después de 12 días",
            },
            {
              name: "_gid",
              domain: "Google Analytics",
              description:
                'Galleta informática establecida por <a href="https://business.safety.google/adscookies/">Google Analytics</a>',
              expiration: "Sesión",
            },
          ],
        },
      },
    ],
  },
};

const servicesLabel =
  "Permite el almacenamiento relacionado con el análisis, por ejemplo, la duración de la visita.";

export { translation, servicesLabel };
